import { Button } from "@material-ui/core";
import ConfigForm, { ConfigInput } from "components/Layout/ConfigForm";
import {
  StandardContainer,
  SubmitButtonsContainer,
} from "components/Layout/StandardStyledComponents";
import React, { useContext } from "react";
import { GET_FLOOR_OVERLAYS } from "lib/buildings";
import { GetFloorOverlaysQueryResult } from "generated/graphql";
import { useQuery } from "@apollo/client";
import { BuildingContext } from "Context/BuildingProvider";

export interface StepFormProps {
  name: string;
  handleStepNameChange: (event: any) => void;
  handleNewLocation: (lat: number, lng: number, floorNumber: number) => void;
  onWaypointCancel: () => void;
}
export default function StepForm({
  name,
  handleStepNameChange,
  handleNewLocation,
  onWaypointCancel,
}: StepFormProps) {
  const { currentBuilding, updateBuilding } = useContext(BuildingContext);
  const { loading, error, data }: GetFloorOverlaysQueryResult = useQuery(
    GET_FLOOR_OVERLAYS,
    {
      variables: {
        buildingId: currentBuilding?.Id,
      },
    }
  );

  const inputs: ConfigInput[] = [
    {
      required: true,
      title: "Step Name",
      placeholder: "Required",
      type: "text",
      onChange: handleStepNameChange,
      xs: 12,
      sm: 6,
      id: "stepName",
      value: name,
    },
    {
      title: "Choose where this step will be done (Optional)",
      type: "mapPoint",
      onNewLocation: handleNewLocation,
      onChange: () => {},
      floorOverlays: data?.FloorOverlay,
      xs: 12,
      sm: 6,
      id: "stepMap",
      cancellable: true,
      onCancel: onWaypointCancel,
    },
  ];
  return (
    <StandardContainer>
      <ConfigForm inputs={inputs}></ConfigForm>
    </StandardContainer>
  );
}
